import { SwapVert } from "@mui/icons-material";
import { IconButton, Menu, MenuItem } from "@mui/material";
import { useState } from "react";

export default function GroupSortMenu({ groupIndex, onClick, groups = [] }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const onOptionClick = (index) => {
    handleClose();
    onClick(index);
  };

  return (
    <>
      <IconButton
        id={`basic-button-${groupIndex}`}
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        size="small"
      >
        <SwapVert fontSize="small" />
      </IconButton>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={{
          list: {
            "aria-labelledby": "basic-button",
          },
        }}
      >
        {groups.map((_, index) =>
          groupIndex !== index ? (
            <MenuItem key={index} onClick={() => onOptionClick(index)}>
              {`Move to Group ${index + 1}`}
            </MenuItem>
          ) : null
        )}
      </Menu>
    </>
  );
}
